import { render, staticRenderFns } from "./bwCloudOSRequestForm.vue?vue&type=template&id=ff144218&scoped=true"
import script from "./bwCloudOSRequestForm.vue?vue&type=script&lang=js"
export * from "./bwCloudOSRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff144218",
  null
  
)

export default component.exports